// const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, "");
var apiUrl = ""
if (window.location.origin == 
"http://localhost:3000") {
apiUrl = "http://localhost:8083"
}
else if (window.location.origin ==
"https://evonext.ai"){
apiUrl = "https://evonext.ai/api"
}
else if (window.location.origin ==
"https://www.evonext.ai"){
apiUrl = "https://www.evonext.ai/api"
}
else {
  apiUrl =  window.location.origin
}

export const API_BASE_URL =
 window.location.origin == 
"http://localhost:3000" ? `${apiUrl}` :
  `${apiUrl}`;
 